import { Link as ReactLink } from "@certn/cascadia-react/components/link/Link";
import { memo } from "react";

import { CascadiaLinkProps } from "./types";

export const Link = memo(function (props: CascadiaLinkProps) {
  return <ReactLink {...props} />;
});
